import { omit } from 'lodash'
import moment from 'moment'

import { isPromise } from './functions'

const pMemoize = (
  func,
  keyResolver,
  ttlResolver,
  shouldCacheResolver = () => true, // determine whether or not cache result or not
  options = {
    skipCacheHeader: false,
    resetCache: false,
    skipCachedValue: false,
    omitFields: [],
  },
) => {
  if (
    typeof func !== 'function' ||
    (keyResolver != null && typeof keyResolver !== 'function') ||
    (ttlResolver != null && typeof ttlResolver !== 'function') ||
    (shouldCacheResolver != null && typeof shouldCacheResolver !== 'function')
  ) {
    throw new TypeError('Expected a function')
  }
  const memoized = function (...args) {
    const key = keyResolver
      ? keyResolver.apply(
          this,
          args.filter((a) => !isPromise(a)), // do not use cacelToken as keyResolver
        )
      : args[0]
    const { cache } = memoized
    const {
      skipCacheHeader,
      skipCachedValue,
      resetCache,
      omitFields = [],
    } = options
    if (resetCache) {
      cache.delete(key)
    }

    if (!skipCachedValue && cache.has(key)) {
      const value = cache.get(key)
      const now = moment().utc().unix()
      if ((!value.ttl || value.ttl > now) && value.data) {
        return new Promise((resolve) => {
          if (!skipCacheHeader && value.data) {
            resolve({
              ...value.data,
              headers: {
                ...value.data.headers,
                'x-from-cache': true,
              },
            })
          } else {
            resolve(value.data)
          }
        })
      }
      cache.delete(key)
    }
    const promise = func.apply(this, args)
    promise.then((data) => {
      const ttl = ttlResolver ? ttlResolver.apply(this, args) : false
      if (shouldCacheResolver(data, args)) {
        const cachingData =
          Array.isArray(data) || omitFields.length === 0
            ? data
            : omit(data, omitFields)
        memoized.cache = cache.set(key, { data: cachingData, ttl }) || cache
      }

      return data
    })
    return promise
  }
  const CacheConstructor = pMemoize.Cache || Map
  memoized.cache = new CacheConstructor()
  return memoized
}

export default pMemoize
